export default __webpack_public_path__ + "media/images/tick-4a4a659d122a0ee458c0f7d071d389a2.svg";